<template>
  <div class="min-h-[60vh] flex flex-col items-center justify-center px-4 py-16 text-center">
    <p class="text-7xl sm:text-8xl font-bold text-indigo-600 tracking-tight">404</p>
    <h1 class="mt-4 text-xl sm:text-2xl font-semibold text-gray-900">
      {{ t('notFound.pageTitle') }}
    </h1>
    <p class="mt-2 max-w-md text-gray-500 text-sm sm:text-base">
      {{ t('notFound.mainMessage') }}
    </p>

    <div class="mt-8 flex flex-col sm:flex-row gap-3 w-full max-w-sm sm:max-w-none sm:w-auto">
      <router-link
        to="/"
        class="inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 transition-colors"
      >
        {{ t('notFound.goHome') }}
      </router-link>
      <router-link
        to="/encuentratucoliving"
        class="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-indigo-200 text-indigo-700 text-sm font-medium hover:bg-indigo-50 transition-colors"
      >
        {{ t('notFound.searchColiving') }}
      </router-link>
      <router-link
        to="/contacto"
        class="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-gray-200 text-gray-600 text-sm font-medium hover:bg-gray-50 transition-colors"
      >
        {{ t('notFound.contactSupport') }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { trackBrokenLink } from '../services/redirectMonitorService'

const { t } = useI18n()
const route = useRoute()

onMounted(() => {
  trackBrokenLink({
    url: window.location.href,
    path: route.fullPath,
    referrer: document.referrer,
    hasSuggestions: false,
  }).catch(() => undefined)
})
</script>
